'use client'
import { ErrorMessage, Form, Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import Modal from '.'
import FormLabel from '../Forms/FormLabel'
import FormikInput from '../Forms/FormikInput'
import GradientButton from '../Forms/GradientButton'
import { LoaderSVG } from '../SVGs/CommonSVG'
import ValidationMsg from '@/Utils/ValidationSchema/ValidationMsg'
import { PhoneNumberSchema, YupObject } from '@/Utils/ValidationSchema'
import usePost from '@/Utils/Hooks/usePost'
import { VerifyWhatsAppAPI } from '@/Utils/APIRequest/Endpoints'
import { CustomToast } from '@/Utils/CustomToast'
import BorderButton from '../Forms/BorderButton'
import { AppStore } from '@/lib/store'
import { getUserDetails } from '@/lib/Features/UserDetails/userDetails'
import { useTranslation } from '@/Utils/Hooks/useTranslate'

const WhatsAppVerifyModal = ({ modal, setModal }) => {
    const dispatch = useDispatch();
    const userDetails: any = useSelector((state: AppStore) => state.userDetailSlice?.userDetails);
    const { translations } = useTranslation();
    const { isPending, mutate } = usePost(VerifyWhatsAppAPI, null, (response) => {
        if (response?.status === 200 || response?.status === 201) {
            CustomToast("success", response?.data?.message || "Confirmation message sent to your WhatsApp number")
            setModal(false)
        }
    }, '')

    const handlePhoneChange = (value, country, setFieldValue) => {
        setFieldValue("country_code", `+${country.dialCode}`)
    }

    return (
        <Modal modalSize="md:w-2/4 lg:w-1/3 2xl:w-1/4" setModal={setModal} headerTitle={translations?.connectWhatsAppModalTitle} childMainClass="!overflow-visible">
            <Formik
                initialValues={{ phone_number: userDetails?.phone_number, country_code: userDetails?.country_code }}
                validationSchema={YupObject({
                    phone_number: PhoneNumberSchema,
                })}
                onSubmit={(values) => {
                    mutate({ phone_number: values.phone_number, country_code: values.country_code } as any)
                }}
            >
                {({ values, setFieldValue }) => (
                    <Form>
                        <div className="mb-4">
                            <FormLabel title={translations?.whatsAppNumber} isRequired />
                            <div className='grid grid-cols-12 sm:gap-4 gap-2'>
                                <div className="sm:col-span-4 col-span-4 relative">
                                    <PhoneInput
                                        preferredCountries={['hk', 'sg', 'in']}
                                        value={values['country_code']}
                                        onChange={(value, country) => handlePhoneChange(value, country, setFieldValue)}
                                        enableSearch={true}
                                        disableSearchIcon={true}
                                        autoFormat={false}
                                        countryCodeEditable={true}
                                        placeholder='+1'
                                        containerClass='!w-full !h-full !rounded-xl border border-gray'
                                        inputClass='form-control !w-full !bg-transparent !border-0 !h-auto !font-normal focus:outline-none !pl-10 sm:!text-lg !text-sm !text-gray !font-medium !h-full placeholder:!text-gray/25'
                                        buttonClass='!bg-transparent hover:!bg-transparent !border-0 !rounded-xl'
                                        dropdownClass='!bg-white !z-[100]'
                                        searchClass='!bg-white !w-full !ml-0 !p-2'
                                    />
                                </div>
                                <div className="sm:col-span-8 col-span-8">
                                    <FormikInput inputProps={{ type: "text", name: "phone_number", placeholder: translations?.enterWhatsAppNumber }} />
                                </div>
                            </div>
                            <ErrorMessage name="phone_number" component="div" render={(msg) =>
                                <ValidationMsg errorMsg={msg} />
                            } />
                        </div>
                        <div className='flex items-center justify-center gap-3.5 mt-5'>
                            <GradientButton buttonType="submit" disabled={isPending} customClass="flex items-center justify-center gap-2">
                                {translations?.submit}
                                {isPending && <LoaderSVG />}
                            </GradientButton>
                            <BorderButton buttonType="button" title={translations?.cancel} onClick={() => setModal(false)} />
                        </div>
                    </Form>
                )}
            </Formik>
        </Modal>
    )
}

export default WhatsAppVerifyModal
